"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flushGetIDsData = exports.getIDs = exports.validateChannelList = void 0;

var _constants = require("./constants");

var validateChannelList = function validateChannelList(notificationMediumId) {
  var channelList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return {
    type: _constants.ValidateChannelsType.VALIDATE_CHANNEL_LIST_REQUEST,
    payload: {
      id: notificationMediumId,
      channelList: channelList
    }
  };
};

exports.validateChannelList = validateChannelList;

var getIDs = function getIDs(notificationMediumId) {
  var channelList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return {
    type: _constants.GetIDsType.GET_IDS_REQUEST,
    payload: {
      id: notificationMediumId,
      channelList: channelList
    }
  };
};

exports.getIDs = getIDs;

var flushGetIDsData = function flushGetIDsData() {
  return {
    type: _constants.GetIDsType.GET_IDS_FLUSH
  };
};

exports.flushGetIDsData = flushGetIDsData;